import { useEffect, useState } from "react";
import { EVENT_DATE } from "@/lib/site";

export default function Countdown() {
  const target = new Date(EVENT_DATE).getTime();
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const diff = Math.max(0, target - now);
  const units = [
    [Math.floor(diff / 86400000), "DAYS"],
    [Math.floor((diff % 86400000) / 3600000), "HRS"],
    [Math.floor((diff % 3600000) / 60000), "MIN"],
    [Math.floor((diff % 60000) / 1000), "SEC"],
  ];

  return (
    <div data-testid="hero-countdown" className="flex flex-wrap items-baseline gap-x-7 gap-y-3">
      <span className="font-sans text-[10px] tracking-[0.35em] text-ink/50">
        T-MINUS TO BRIEFING —
      </span>
      {units.map(([value, label]) => (
        <span key={label} className="flex items-baseline gap-1.5">
          <span className="font-serif text-3xl font-medium tabular-nums text-wine md:text-4xl">
            {String(value).padStart(2, "0")}
          </span>
          <span className="font-sans text-[9px] tracking-[0.3em] text-ink/50">{label}</span>
        </span>
      ))}
    </div>
  );
}
